"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tab: function() {
        return _Tab.Tab;
    },
    renderTab_unstable: function() {
        return _renderTab.renderTab_unstable;
    },
    tabClassNames: function() {
        return _useTabStylesstyles.tabClassNames;
    },
    tabReservedSpaceClassNames: function() {
        return _useTabStylesstyles.tabReservedSpaceClassNames;
    },
    useTabA11yBehavior_unstable: function() {
        return _useTab.useTabA11yBehavior_unstable;
    },
    useTabAnimatedIndicatorStyles_unstable: function() {
        return _useTabAnimatedIndicatorstyles.useTabAnimatedIndicatorStyles_unstable;
    },
    useTabBase_unstable: function() {
        return _useTab.useTabBase_unstable;
    },
    useTabButtonStyles_unstable: function() {
        return _useTabStylesstyles.useTabButtonStyles_unstable;
    },
    useTabContentStyles_unstable: function() {
        return _useTabStylesstyles.useTabContentStyles_unstable;
    },
    useTabIndicatorStyles_unstable: function() {
        return _useTabStylesstyles.useTabIndicatorStyles_unstable;
    },
    useTabStyles_unstable: function() {
        return _useTabStylesstyles.useTabStyles_unstable;
    },
    useTab_unstable: function() {
        return _useTab.useTab_unstable;
    }
});
const _Tab = require("./Tab");
const _renderTab = require("./renderTab");
const _useTab = require("./useTab");
const _useTabStylesstyles = require("./useTabStyles.styles");
const _useTabAnimatedIndicatorstyles = require("./useTabAnimatedIndicator.styles");
